import React from "react";
import Board from "components/Common/Board/Board";
import styled from "styled-components";

export interface PageFilterPanelProps {
  children: React.ReactNode;
  title?: string;
}

export const FilterBoard = ({ children, title }: PageFilterPanelProps) => {
  return (
    <FilterBoardLayout>
      {title && <h1>{title}</h1>}
      {children}
    </FilterBoardLayout>
  );
};

export const FilterBoardLayout = styled(Board)`
  padding: 3rem 4rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  h1 {
    color: ${({ theme }) => theme.color.text.default};
    font-size: 2.8rem;
    font-weight: 600;
    line-height: 36px; /* 128.571% */
    letter-spacing: -0.56px;
  }
`;

export const NestFilterLayout = styled.div`
  display: flex;
  gap: 6rem;
`;
